import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";

import Footer from "components/Footers/Footer";
import Navbar from "components/Navbars/AuthNavbar";
// components

import CardLineChart from "components/Cards/CardLineChart.js";
import CardBarChart from "components/Cards/CardBarChart.js";
import ColumnChart from "components/Cards/ColumnChart";
import MonthColumnchart from "components/Cards/MonthColumnchart";
import CardStats from "components/Cards/CardStats";
import HeaderStats from "components/Headers/HeaderStats";
import ExpensesTypewisetable from "components/Cards/ExpensesTypewisetable";

export default function Dashboard() {




  const history = useHistory();

  useEffect(() => {
    // Check if user is not logged in (localStorage is empty)
    if (!localStorage.getItem("userData")) {
      // Redirect to the login page
      history.push("/login");
    }
  }, [history]);




  //get userid form loca storage
  const storedUserData = localStorage.getItem('userData');
  let userId = '';
  if (storedUserData) {
    const userData = JSON.parse(storedUserData);
    userId = userData.userId;
  }


  return (
    <>
      <Navbar />
      {/* <div className="flex flex-wrap mb-3">
        <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
          <HeaderStats/>
        </div>
      </div> */}
      <HeaderStats/>

      <div className="flex flex-wrap">
        <div className="w-full xl:w-8/12 mb-12 xl:mb-0 px-4">
          <CardLineChart />
        </div>
        <div className="w-full xl:w-4/12 px-4">
          <CardBarChart />
        </div>
      </div>
      <div className="flex flex-wrap mt-4">
        <div className="w-full xl:w-8/12 mb-12 xl:mb-0 px-4">
          <ColumnChart />
        </div>
        <div className="w-full xl:w-4/12 px-4">
          <MonthColumnchart />
        </div>  
      </div>
      <div className="flex flex-wrap mt-4">
        <div className="w-full xl:w-12/12 mb-12 xl:mb-0 px-4">
          <ExpensesTypewisetable />
        </div>
      </div>
      <Footer />
    </>
  );
}
